import { Form, Formik } from "formik"
import { FC, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ReactComponent as ArrowIcon } from "../../assets/icons/button-arrow.svg"
import RSVPLogo from "../../assets/images/rsvp/peoplevine-rsvp-logo-white-orange.png"
import { patternGenerator } from "../Patterns/patternsGenerator"
import ItemsWrapper from "./components/ItemsWrapper"
import useRSVPForm from "./hooks/useRSVPForm"
import "./RSVPForm.scss"
import { validationSchema } from "./types"

const patterns = patternGenerator({ quantity: 6, theme: "dark" })

export const RSVPForm: FC = () => {
  const { initialValues, formItems, onSubmit } = useRSVPForm()
  const navigate = useNavigate()

  const handleSubmit = async (values: any, formikHelpers: any) => {
    await onSubmit(values)
  }

  return (
    <div className='main-contact' id='capterra-contact' role={"presentation"}>
      <div className='ornament-block'>{patterns}</div>
      <div className='container'>
        <div className='main-contact__wrapper'>
          <div className="main-contact__image">
            <img src={RSVPLogo} alt='RSVP Logo' />
          </div>
          <h2 className='main-contact__title'>RSVP Community - Partner Application</h2>
          <div className='main-form-block'>
            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validationSchema={validationSchema}
            >
              {form => (
                <Form className='main-login-form'>
                  {formItems.map((item, index) => (
                    <ItemsWrapper
                      key={`rsvp-form__items-wrapper-${index}`}
                      {...item}
                    />
                  ))}
                  <div className='login-form__button'>
                    <button type='submit' disabled={form?.isSubmitting}>
                      Submit Application
                      <ArrowIcon />
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  )
}
